export default "__VITE_ASSET__DSaxRmw$__"